import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DataTestTypeWithIconComponent } from './data-test-type-with-icon.component';

@NgModule({
  declarations: [DataTestTypeWithIconComponent],
  imports: [CommonModule, FontAwesomeModule],
  exports: [DataTestTypeWithIconComponent],
})
export class DataTestTypeWithIconModule {}
